<template>
  <div class="system-dialog-content">
    <div class="system-dialog-content__message">
      {{ messageText }}
    </div>

    <SmartInputText
      v-model="inputText"
      :make-focus="true"
      class="system-dialog-content__prompt"
      @keyup.enter.native="closeDialog(inputText)"
    />

    <div class="system-dialog-content__actions">
      <CamsButton
        class="system-dialog-content__action-button"
        type="button"
        @click="closeDialog()"
      >
        {{ $t(rejectionText) }}

      </CamsButton>

      <CamsButton
        class="system-dialog-content__action-button"
        priority="primary"
        type="button"
        @click="closeDialog(inputText)"
      >
        {{ $t(approveText) }}
      </CamsButton>
    </div>
  </div>
</template>

<script>
import {methodsForDialogMixin} from "./mixins.js";

/**
 * Компонент диалога для своего prompt.
 */
export default {
  mixins: [methodsForDialogMixin],
  props: {
    /**
     * Текст основного сообщения.
     */
    messageText: {
      type: String,
      default: "Вопрос?",
    },
    /**
     * Текст для кнопки подтверждения.
     */
    approveText: {
      type: String,
      default: 'confirm',
    },
    /**
     * Текст для кнопки отклонения.
     */
    rejectionText: {
      type: String,
      default: 'cancel',
    },
  },
  data() {
    return {
      inputText: "",
    };
  },
};
</script>

<style lang="scss">
@import "./scss/style.scss";
</style>
